module.exports = __webpack_public_path__ + "assets/images/pages/workshops/lab.png?d3d20704";